import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

const cfg  = window.ebusManufacturers || {};
const api  = (cfg.apiUrl || '').replace(/\/?$/, '/');
const lang = cfg.lang || '';

const apiUrl = path => api + path + (lang ? '?lang=' + lang : '');

export const useManufacturersStore = defineStore('manufacturers', {
    state: () => ({
        manufacturers: [],
        currentManufacturer: null,
        activeFilter: '*',
        activeIndex: -1,
    }),

    getters: {
        uniqueCountries: (state) => {
            const seen = {};
            const out  = [];
            state.manufacturers.forEach(m =>
                m.countries.forEach(c => { if (!seen[c.slug]) { seen[c.slug] = true; out.push(c); } })
            );
            return out;
        },
    },

    actions: {
        async loadManufacturers() {
            try {
                this.manufacturers = await apiFetch({ url: apiUrl('manufacturers') });
            } catch (error) {
                console.error('Error loading manufacturers:', error);
            }
        },

        setFilter(f) {
            this.activeFilter = f;
        },

        clearFilter() {
            this.activeFilter = '*';
        },

        async loadDetail(id) {
            this._abortCtrl?.abort();
            this._abortCtrl = new AbortController();
            try {
                this.currentManufacturer = await apiFetch({
                    url: apiUrl(`manufacturers/${id}`),
                    signal: this._abortCtrl.signal,
                });
            } catch (e) {
                if (e.name !== 'AbortError') console.error(e);
            }
        },
    },
});
